<template>
  <div class="pb-5 pt-0">
    <OpportunitiesList />
  </div>
</template>

<script>
import hubbdata from "@/hubbdata";
import OpportunitiesList from "@/components/Opportunities/OpportunitiesList";

export default {
  name: "Opportunities",
  components: {
    OpportunitiesList,
  },
  computed: {
    hubbdata() {
      return hubbdata.getters.translations;
    },
  },
  methods: {
    linkSet(url) {
      if (url.indexOf("http") > -1){
        return true
      } else {
        return false
      }
    },
  },
  mounted: function() {
    if (this.organisations !== undefined) {
      ga('set', 'title', "Organisations"); // eslint-disable-line
      ga('send', 'pageview', location.href); // eslint-disable-line
      hubbdata.dispatch("initDB");
    }
  },
}
</script>
